exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".X6LMWvod566P68{padding:0 12px;word-break:break-word}.X6LMWvod566P68 p{margin:0 0 16px}", ""]);

// exports
exports.locals = {
	"confirmContainer": "X6LMWvod566P68"
};